import { Component, SimpleChanges, ViewChild, Output, EventEmitter, ElementRef, Input, PLATFORM_ID, Inject } from '@angular/core';

import { ComponentBase, ComponentModalBase } from '@framework/base/component';
import { ToastService, UploaderService } from '@framework/services';
import { Store } from '@ngrx/store';
import { CoreState } from '@app/store/core/states';
// import { VideoSDK } from "@videosdk.live/js-sdk";
// import { VirtualBackgroundProcessor } from "@videosdk.live/videosdk-media-processor-web";
import { interval, Subscription } from 'rxjs';
// import RecordRTC from 'recordrtc';
import { CreateMediaInputApiModel } from '@app/store/http/models/input';
import { UploaderConfig, Callback } from '@framework/models';
import { UtilityHelper } from '@framework/utilities';
import { Actions, ofType } from '@ngrx/effects';
import { storyActions } from '@modules/company-admin/store/actions';
import { isPlatformBrowser } from '@angular/common';
import { isMobileCaptureViewport, recordRtcStoryOptions, storyVideoConstraints } from '@modules/story/components/video-recorder-media/mobile-capture.util';
import { inspectVideoUploadSize, ScreenWakeLock, shouldShrinkMobileVideo } from '@modules/story/components/storyflow-card-preview/upload-ux.util';
import { shrinkMobileCameraRoll } from '@modules/story/components/storyflow-card-preview/shrink-mobile-video';
declare var MediaRecorder: any;
declare var $: any;
let meeting;
declare global {
  interface Window {
    streamReference: any;
  }
}

@Component({
  selector: 'request-video-recorder-media',
  templateUrl: './request-video-recorder-media.component.html',
  styleUrls: ['./request-video-recorder-media.component.scss'],
  host: {
    '[class.greeting-choice-active]': 'showGreetingChoice',
  },
})


export class RequestVideoRecorderMediaComponent extends ComponentModalBase<any>  {
  @ViewChild('videoElement') videoElement: ElementRef;
  @ViewChild('canvas') canvasRef: ElementRef;
  @ViewChild('canvasdata') canvasCamera: ElementRef;
  @ViewChild('greetingUploadInput') greetingUploadInput!: ElementRef<HTMLInputElement>;

  isRecording = false;
  showalways = false;
  public showGreetingChoice = false;
  public shrinkingGreeting = false;
  timers: number = 5; // Initial timer value in seconds
  timerSubscripti: Subscription;
  public showWhileRecording:boolean = false;
  public initiaCameraSelect:boolean = true;
  public isPause:boolean = false;
  public hideAlways:boolean = false;
  mediaRecorder: MediaRecorder;
  recordedChunks: Blob[] = [];
  public constraints:any;
  public loadColorSuccessSubscription: Subscription;
  public stream:any;
  public ishowLoader:boolean = true
  public permissionBlockedMessage = '';
  public blur:boolean = false;
  public colorValue:any = '#000000'
  public primary_color:any;
  public themeButtonColor: string;
  public themeButtonTextColor: string;
  public canvasCtx:any;
  timer: number;
  public videoProcessor:any;
  public processedStream;
  public recorder;
  private uploader: any;
  public audioStream:any;
  public storyParam:any;
  public questionModels:any[] = [];
  public campaignDetail:any;
  public hideNavigation:boolean = false;
  public audiodeveices:any = [];
  public videodevices:any =[];
  public defaultaudio:any
  public defaultcamera:any;
  public stopRecordingVideo:boolean = false;
  public availableCamera:any[] = [];
  public availableaudio:any[] = [];
  public counterQuestion:number = 0;
  public uploaderViewModel: any = {
    errorMsg: 'An error occurred while uploading.',
    isError: false,
    progress: 0,
    progressCss: '0%',
    isUploading: false
  };
 public  isBrowser:boolean
 showCloseConfirm:boolean =false;
  private timerSubscription:Subscription
  private VideoSDK: any;
private VirtualBackgroundProcessor: any;
private RecordRTC: any;
  removedisabled: boolean = true;

  get selectedAudioLabel(): string {
    return (
      this.availableaudio?.find((d) => d.deviceId === this.defaultaudio)
        ?.label || "Built-in Microphone"
    );
  }

  get selectedCameraLabel(): string {
    return (
      this.availableCamera?.find((d) => d.deviceId === this.defaultcamera)
        ?.label || "Camera"
    );
  }

// public videoProcessor: any;
  constructor( private uploaderService: UploaderService,  private utility: UtilityHelper,
    private store$: Store<CoreState>,
    @Inject(PLATFORM_ID) platformId: Object,
    private actions$: Actions,
    private toasterService: ToastService){
    super()
     this.isBrowser = isPlatformBrowser(platformId);

     if(this.isBrowser){
      this.loadVideoSDKDependencies()
     }
  }
  protected onInit(): void {


    if(this.isBrowser){
    this.themeButtonColor = this.initialState?.themeButtonColor;
    this.themeButtonTextColor = this.initialState?.themeButtonTextColor;
    this.store$.dispatch(new storyActions.GetColor(this.initialState?.currentCompany?.id));
    this.timer = 0;

    if (this.initialState?.allowVideoUpload && !this.initialState.isCamera && !this.initialState.isCameraOnly) {
      this.showGreetingChoice = true;
      this.ishowLoader = false;
    } else {
      this.initCameraDevices();
    }


     if(this.initialState.questionModels && this.initialState.questionModels.length && this.initialState.interViewStyle){
      //  this.storyParam = this.initialState.questionModels[0].storyPrompt
       this.initialState.questionModels =  this.initialState.questionModels.map((item)=>{
        return{
          storyPrompt:item.title,
         slug:item.slug,
        storyPprompt_id:item.question_id_campaign,
        campaign_id:item.id_campaign
        }
       })
       this.storyParam = this.initialState.questionModels[0].storyPrompt
     }

    else if(!this.initialState.isCameraOnly  && !this.initialState.questionModels.length && !this.initialState.interViewStyle){
      this.storyParam = this.initialState.storyParam ? this.initialState.storyParam : this.initialState?.currentCompany?.default_story_prompt;
     }
    if(this.initialState.questionModels.length){
      this.questionModels = this.initialState.questionModels;
      this.storyParam = this.initialState.questionModels[0].storyPrompt;
     }
     else{
      this.hideNavigation = true;
     }
      


     if(this.initialState.interViewStyle){
      this.hideNavigation = false;
     }
     else{
      if(this.initialState.showPreviousNextButton){
        this.hideNavigation = false;
      }
      else{
        this.hideNavigation = true;
      }
     }
    // this.hideNavigation =  this.questionModels &&  this.questionModels.length == 0 ? true : false
    //  this.hideNavigation = this.initialState.showPreviousNextButton ?  false : true;
    //  this.hideNavigation = this.initialState.interViewStyle ?  false : true
      setTimeout(()=>{
       this.initUploader();
      },100)
      this.loadColorSuccessSubscription = this.actions$.pipe(
        ofType<storyActions.GetColorSuccess>(storyActions.ActionTypes.GET_BUTTON_COLOR_SUCCESS)
      ).subscribe((action: any) => {
        if(action && action.response && action.response && action.response.length){
          this.primary_color = action.response.find(item => item.button == 11).color;
          if (!this.themeButtonColor) {
            this.themeButtonColor = action.response.find(item => item.button == 8)?.color;
          }
          if (!this.themeButtonTextColor) {
            this.themeButtonTextColor = action.response.find(item => item.button == 9)?.color;
          }
         }
        
  
      })
  
    }
  }

  private initCameraDevices(): void {
    if (!this.isBrowser) {
      return;
    }

    navigator.mediaDevices.enumerateDevices()
      .then(devices => {
        this.availableCamera = devices.filter(device => device.kind === 'videoinput');
        this.availableaudio = devices.filter(device => device.kind === 'audioinput');
        if (this.availableCamera.length > 0) {
          this.defaultcamera = this.availableCamera[0].deviceId;
        }
        if (this.availableaudio.length > 0) {
          this.defaultaudio = this.availableaudio[0].deviceId;
        }

        this.initializeWebcam();
        this.initialcamra();
      })
      .catch(error => console.error('Error enumerating devices:', error));
  }

  selectRecordVideo(): void {
    if (!this.isBrowser) {
      return;
    }
    this.showGreetingChoice = false;
    this.ishowLoader = true;
    this.initCameraDevices();
  }

  triggerGreetingUpload(): void {
    if (!this.isBrowser) {
      return;
    }
    this.greetingUploadInput?.nativeElement?.click();
  }

  onGreetingFileSelected(event: Event): void {
    if (!this.isBrowser) {
      return;
    }
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) {
      return;
    }
    if (!file.type.startsWith('video/')) {
      input.value = '';
      return;
    }
    const mobile = isMobileCaptureViewport();
    const sizeGuard = inspectVideoUploadSize(file.size, { mobile });
    if (!sizeGuard.allowed) {
      input.value = '';
      this.toasterService.error(sizeGuard.message);
      return;
    }
    input.value = '';
    void this.emitGreetingFile(file, mobile, sizeGuard.warn);
  }

  private async emitGreetingFile(file: File, mobile: boolean, warned: boolean): Promise<void> {
    this.shrinkingGreeting = shouldShrinkMobileVideo(file.size, mobile);
    const wakeLock = new ScreenWakeLock();
    let uploadFile = file;
    try {
      if (this.shrinkingGreeting) {
        await wakeLock.acquire();
      }
      uploadFile = await shrinkMobileCameraRoll(file, { mobile });
    } finally {
      this.shrinkingGreeting = false;
      await wakeLock.release();
    }
    const afterShrink = inspectVideoUploadSize(uploadFile.size, { mobile });
    if (afterShrink.warn) {
      this.toasterService.warning(afterShrink.message);
    } else if (warned && !mobile) {
      this.toasterService.warning(inspectVideoUploadSize(file.size).message);
    }
    this.onClose.emit({
      blobcontent: uploadFile,
      campaignDetail: null,
    });
  }

  async loadVideoSDKDependencies() {
    if (typeof window !== 'undefined') {
      const { VideoSDK } = await import("@videosdk.live/js-sdk");
      const { VirtualBackgroundProcessor } = await import("@videosdk.live/videosdk-media-processor-web");
      const RecordRTC = (await import('recordrtc')).default;
  
      this.VideoSDK = VideoSDK;
      this.VirtualBackgroundProcessor = VirtualBackgroundProcessor;
      this.RecordRTC = RecordRTC;
    }
  }
  
  

  protected onDestroy(): void {
    if(this.isBrowser){
      if (this.stream) {
        // this.stream.getTracks().forEach(track => track.stop());
      }
    }

  }

  protected onChanges(changes: SimpleChanges): void {

  }

  protected onDoCheck(): void {

  }

  protected onAfterContentInit(): void {

  }

  protected onAfterContentChecked(): void {

  }

  protected onAfterViewInit(): void {

  }

  protected onAfterViewChecked(): void {

  }

  //  ngOnInit(): void {
  //     this.initializeWebcam();
  //  }


  private initUploader() {
    if(this.isBrowser){
      let config = new UploaderConfig();
      config.companyId = this.initialState.companyID;
      config.isAnonymous = this.initialState.inbound_builder;
      config.validate = {
        imageMinHeight: 480,
        imageMinWidth: 640,
        allowedExtensions: ['gif', 'jpeg', 'jpg', 'png', 'mp4', 'mpg', 'mov']
      };
      config.messages = {
        imageDimensionError: 'Use a larger image - 640 x 480px minimum.',
        typeError: 'Acceptable file formats are gif, jpg, jpeg, png, mp4, mpg and mov.'
      };
  
      let callbacks = new Callback();
      callbacks.onSubmit = this.onUploaderSubmit.bind(this);
      callbacks.onComplete = this.onUploaderComplete.bind(this);
      // callbacks.onError = this.onUploaderError.bind(this);
      callbacks.onProgress = this.onProgress.bind(this);
      this.uploader = this.uploaderService.s3Uploader(config, callbacks);
    }



  }

  private onProgress(id, name, loaded, total) {
    if(this.isBrowser){
      const percent = (loaded / total) * 100;
      this.uploaderViewModel.progress = percent;
      this.uploaderViewModel.progressCss = `${percent}%`;
    }

  }

  startTimers(): void {
    if(this.isBrowser){
    this.timerSubscripti = interval(1000).subscribe(() => {
      if (this.timers > 0) {
        this.timers--;
      } else {
        if(this.initialState.isCamera){
          this.CapturePhoto();
        }else{
          this.removedisabled = false;
         this.playVideo();
        }
         // Trigger photo capture when timer reaches zero
        this.timerSubscripti.unsubscribe(); // Stop the timer
      }
    });
  }
  }

  retakeVideo(){
    if(this.isBrowser){
    this.timerSubscripti.unsubscribe();
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
    this.isPause = false
    this.startTimers();
    this.timers = 5;
    this.timer = 0;
    }  //Reset timer to 3 minutes
  }

  private onUploaderSubmit(id, fileName) {
    
    if(this.isBrowser){
    this.uploaderViewModel.progress = 0;
    this.uploaderViewModel.progressCss = '0%';
    this.uploaderViewModel.isUploading = true;
    this.uploaderViewModel.isError = false;
    }
  }

  private onUploaderComplete(id, name, responseJSON, maybeXhr) {

    if(this.isBrowser){
    this.uploaderViewModel.isUploading = false;

    if (responseJSON.success) {
      let createMediaInputData = new CreateMediaInputApiModel();
      createMediaInputData.origname = name;
      createMediaInputData.size = this.uploader.getSize(id);
      const fileInfo = this.uploaderService.getUploadedFile(id);
      createMediaInputData.path = fileInfo.path;
      createMediaInputData.source = fileInfo.name;
      createMediaInputData.filename = fileInfo.name;
      createMediaInputData.type = fileInfo.type;
      createMediaInputData.story_id = 0;

      var url = 'https://images.goodseeker.com/goodseeker'+fileInfo.path+'/'+fileInfo.name

      this.addSolidcolor(url)
    }
  }
  }

  async initialcamra(){
 if(this.isBrowser){
  this.videoProcessor = new this.VirtualBackgroundProcessor();
  if (!this.videoProcessor.ready) {
    await this.videoProcessor.init();
  }
 }


  }



 async startBlurVirtualBackground() {
  if(this.isBrowser){
    this.blur = true;
    let config;
      config = {
        type: "blur", // "blur"
        imageUrl: "https://www.shutterstock.com/shutterstock/photos/1582221163/display_1500/stock-photo-small-vga-camera-for-micro-controllers-x-pixels-demention-1582221163.jpg",
      };
    
      //console.log(">>",this.videoProcessor.ready)
      const stream = await this.VideoSDK.createCameraVideoTrack({
        cameraId: this.defaultcamera,
        optimizationMode: "motion",
        multiStream: false,
      });
      const processedStream = await this.videoProcessor.start(stream, config);
      //console.log(">>>>",processedStream)
      this.processedStream = processedStream;
      this.videoElement.nativeElement.srcObject = processedStream;
  }

    // this.drawToCanvas()
  };
   async addSolidcolor(url){
    if(this.isBrowser){
      let config;
      this.blur = true;
      config = {
        type: "image", // "blur"
        imageUrl: url
      };
      //console.log(">>",this.videoProcessor.ready)
      const stream = await this.VideoSDK.createCameraVideoTrack({
        cameraId: this.defaultcamera,
        optimizationMode: "motion",
        multiStream: false,
      });
      const processedStream = await this.videoProcessor.start(stream, config);
      //console.log(">>>>",processedStream)
    this.processedStream = processedStream;
     this.videoElement.nativeElement.srcObject = processedStream;
    }

  //  this.drawToCanvas()
  
    
   }

   initializeWebcam() {
    if(this.availableCamera.length > 0 && this.defaultcamera && this.availableaudio.length && this.defaultaudio){
       navigator.mediaDevices.getUserMedia({
         video: storyVideoConstraints(this.defaultcamera),
         audio:{deviceId: this.defaultaudio, echoCancellation:true}
       })
       .then(stream1 => {
          this.permissionBlockedMessage = '';
          this.videoElement.nativeElement.srcObject = stream1;
          this.audioStream = stream1;
          this.canvasCtx = this.canvasCamera.nativeElement.getContext('2d');
          // this.drawToCanvas();
          this.videoElement.nativeElement.muted = true;
          this.ishowLoader =false;
          this.stream = stream1

         // this.mediaRecorder = new MediaRecorder(stream1);
 
         // this.mediaRecorder.ondataavailable = (event) => {
         //   if (event.data.size > 0) {
         //     this.recordedChunks.push(event.data);
         //   }
         // };
 
         // this.mediaRecorder.onstop = () => {
         //   const blob = new Blob(this.recordedChunks, { type: 'video/mp4' });
         //   if(this.stopRecordingVideo){
         //   if(this.initialState.showPreviousNextButton && !this.initialState.interViewStyle && this.campaignDetail){
         //     let obj ={
         //       blobcontent :blob,
         //       campaignDetail: this.campaignDetail
         //     }
         //     this.onClose.emit(obj)
         //   }
         //   else{
         //     let obj ={
         //       blobcontent :blob,
         //       campaignDetail:null
         //     }
         //     this.onClose.emit(obj)
         //   }
           
         //   }
          
         //   else{
         //     this.onClose.emit(false)
         //   }


        
         //   //  const url = URL.createObjectURL(blob);
         //   //  this.recordedChunks = [];
         //   //  const a = document.createElement('a');
         //   //  document.body.appendChild(a);
         //   //  a.style = 'display: none';
         //   //  a.href = url;
         //   //  a.download = 'recorded-video.webm';
         //   //  a.click();
         //   //  window.URL.revokeObjectURL(url);
         // };
     
      
       })
       .catch(error => {
         console.error('Error accessing webcam:', error);
         this.showCameraPermissionMessage(error);
       });
    } else {
       this.showCameraPermissionMessage();
    }

//  this.videoElement.nativeElement.srcObject = combinedStream;
//  this.stream = combinedStream
//  this.mediaRecorder = new MediaRecorder(combinedStream);

//  this.mediaRecorder.ondataavailable = (event) => {
//    if (event.data.size > 0) {
//      this.recordedChunks.push(event.data);
//    }

//  };

//  this.mediaRecorder.onstop = () => {
//    const blob = new Blob(this.recordedChunks, { type: 'video/mp4' });
//    if(this.stopRecordingVideo){
//      this.onClose.emit(blob)
//    }
//    else{
//      this.onClose.emit(false)
//    }

//     const url = URL.createObjectURL(blob);
//     this.recordedChunks = [];
//     const a = document.createElement('a');
//     document.body.appendChild(a);
//     a.style = 'display: none';
//     a.href = url;
//     a.download = 'recorded-video.webm';
//     a.click();
//     window.URL.revokeObjectURL(url);
//  };
  }

  private showCameraPermissionMessage(error?: any): void {
    const name = error?.name || '';
    const isPermissionIssue =
      !error ||
      name === 'NotAllowedError' ||
      name === 'PermissionDeniedError' ||
      name === 'SecurityError';

    if (!isPermissionIssue) {
      return;
    }

    this.ishowLoader = false;
    this.permissionBlockedMessage =
      'Please allow camera and microphone access in your browser to record video.';
  }




    startRecording(): void {
    // this.mediaRecorder.start();
    this.isRecording = true;

  }

  startinitalrecording(){
    if(this.isBrowser){
    this.initiaCameraSelect = false;
    this.showWhileRecording = false;
    // this.initializeWebcam()
    if(this.initialState.interViewStyle){
      this.hideNavigation = false;
    }
    else{
      this.hideNavigation = true;
    }

    if(!this.initialState.isCamera){
      this.showWhileRecording = true;
      this.showalways = true;
    }
    
       this.startTimers();
      }
    
  }

  playVideo(){
    if(this.isBrowser){
    this.isRecording = false;
    if(this.isPause){
    //  this.mediaRecorder.resume();
    this.recorder.resumeRecording();
      this.isPause = false;
      this.showWhileRecording = true;
      this.startTimer();
    }
    else{
  //     var finalStream = new MediaStream()
  // this.recorder = RecordRTC(this.processedStream, {
  //       type: 'video'
  //   });
  if(!this.blur){
    this.processedStream = this.audioStream;
  }
  let arstream = this.processedStream
var finalStream = new MediaStream();
this.audioStream.getAudioTracks().forEach(track => {
    finalStream.addTrack(track);
});
arstream.getVideoTracks().forEach(track => {
    finalStream.addTrack(track);
});
this.recorder = this.RecordRTC(finalStream, recordRtcStoryOptions());
    this.recorder.startRecording();
      // this.mediaRecorder.start();
      this.showalways = true;
      this.showWhileRecording = true;
      this.hideAlways = true
      this.startTimer();
   
    }
    }
  }

  stopRecordingVideoFile(): void {
    if(this.isBrowser){
      this.isRecording = false;
      this.stopRecordingVideo=true
      this.stopTimer();
      this.recorder.stopRecording(()=>{
        let blob = this.recorder.getBlob()
        if(this.stopRecordingVideo){
          if(this.initialState.showPreviousNextButton && !this.initialState.interViewStyle && this.campaignDetail){
            let obj ={
              blobcontent :blob,
              campaignDetail: this.campaignDetail
            }
            this.onClose.emit(obj)
          }
          else{
            let obj ={
              blobcontent :blob,
              campaignDetail:null
            }
            this.onClose.emit(obj)
          }
          
          }
         
          else{
            this.onClose.emit(false)
          }
      })
    }

    // this.mediaRecorder.stop();

  }


  pauseRecordingmedia(){
    if(this.isBrowser){
      this.recorder.pauseRecording(); 
      this.isPause = true
      this.pauseTimer();
      this.showWhileRecording = false;
    }
   // this.mediaRecorder.pause();

  }
  private startTimer(): void {
    if(this.isBrowser){
      this.timerSubscription = interval(1000).subscribe(() => {
        this.timer++;
 });
    }

  }

  private pauseTimer(): void {
    if(this.isBrowser){
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
  }
  }

  private stopTimer(): void {
    if(this.isBrowser){
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
    this.timer = 0;
    }  //Reset timer to 3 minutes
  }

  // formatTime(seconds: number): string {
  //   const minutes = Math.floor(seconds / 60);
  //   const remainingSeconds = seconds % 60;
  //   return `${this.pad(minutes)}:${this.pad(remainingSeconds)}`;
  // }

  formatTime(seconds: number): string {
    if(this.isBrowser){
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = seconds % 60;
      return `${this.pad(hours)}:${this.pad(minutes)}:${this.pad(secs)}`;
    }

  }
  private pad(val: number): string {
    // if(this.isBrowser){
      return val < 10 ? `0${val}` : val.toString();
    // }

  }

  close(){
    // if(this.isBrowser){
      this.onClose.emit(false)
    // }

  }

  getaudioData(item){
    if(this.isBrowser){
      this.blur = false
      this.defaultaudio = item.deviceId;
      this.initializeWebcam()
    }

  }

  getVideoData(item){
    if(this.isBrowser){
      this.blur = false
      this.defaultcamera = item.deviceId;
      this.initializeWebcam()
    }


  }

  next(){
    if(this.isBrowser){
      this.counterQuestion ++ ;
      if(this.counterQuestion > this.questionModels.length - 1){
        this.counterQuestion = 0,
        this.campaignDetail = null;
        if(!this.initialState.interViewStyle){
          this.storyParam = this.questionModels[0].storyPrompt;
        }
        else{
          this.storyParam =this.questionModels[0].storyPrompt;
        }
      }else{
        this.storyParam = this.questionModels[this.counterQuestion].storyPrompt
        this.campaignDetail = {
          storyParam:this.questionModels[this.counterQuestion].storyPrompt,
          storeSlugForCampaignQuestion: this.questionModels[this.counterQuestion].slug,
          question_id_campaign: this.questionModels[this.counterQuestion].storyPprompt_id,
          campaign_id:this.questionModels[this.counterQuestion].campaign_id
        }
      }
    }

  }
  prev(){
    if(this.isBrowser){
    this.counterQuestion --
    if(this.counterQuestion < 0){
      this.counterQuestion = this.questionModels.length - 1;
      this.campaignDetail = null;
      if(!this.initialState.interViewStyle){
        this.storyParam =  this.initialState?.currentCompany?.default_story_prompt;
      }
      else{
        this.storyParam =  this.initialState?.questionModels[this.questionModels.length - 1].storyPrompt
      }
    }else{
      this.campaignDetail = {
        storyParam:this.questionModels[this.counterQuestion].storyPrompt,
        storeSlugForCampaignQuestion: this.questionModels[this.counterQuestion].slug,
        question_id_campaign: this.questionModels[this.counterQuestion].storyPprompt_id,
        campaign_id:this.questionModels[this.counterQuestion].campaign_id
      }
      this.storyParam = this.questionModels[this.counterQuestion].storyPrompt
    }
  //   }
  // //   const videoProcessor = new VirtualBackgroundProcessor();


  // // // Initialize processor if not ready
  // // if (!videoProcessor.ready) {
  // //   await videoProcessor.init();
  // // }

  // // // Configuration for starting processor
  // // const config = {
  // //   type: "image", // "blur"
  // //    imageUrl: "https://singlecolorimage.com/get/33fd8f/640x360.png",
  // //   // Here is a list of background images you can use for your project.
  // //   // imageUrl: "https://cdn.videosdk.live/virtual-background/beach.jpeg",
  // //   // imageUrl: "https://cdn.videosdk.live/virtual-background/san-fran.jpeg",
  // //   // imageUrl: "https://cdn.videosdk.live/virtual-background/paper-wall.jpeg",
  // // };

  // // // Getting stream from webcam
  // // // const stream = await VideoSDK.createCameraVideoTrack({
  // // //   cameraId: this.defaultcamera,
  // // //   optimizationMode: "motion",
  // // //   multiStream: false,
  // // // });
  // // // const processedStream = await videoProcessor.start(stream, config);
  // // // meeting?.changeWebcam(processedStream);
  // // videoProcessor.updateProcessorConfig(config);
  // }
  }
  }
  

  oncolorChange(event){
    if(this.isBrowser){
    this.colorValue = event;
    this.drawSolidColor(this.colorValue)
    }

  }
  drawSolidColor(color: string) {
    if(this.isBrowser){
    const canvas: HTMLCanvasElement = this.canvasRef.nativeElement;
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = color;
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    this.convertToImage()
    }
  }

  // Function to convert canvas content to an image
  convertToImage() {
    if(this.isBrowser){
    const canvas: HTMLCanvasElement = this.canvasRef.nativeElement;
    const imageData = canvas.toDataURL('image/png'); // Convert canvas to data URL
   // Set the src of the image element
   this.getBase64ImageFromUrl(imageData).then((res: any) => {
    const imageEditedBlob = this.utility.File.b64ToBlob(res.replace(/^data:(image|binary)\/[^;]+;base64,/, ''), 'image/png');
    //this.previewMedia.fullsize = imageEditedB64;
    imageEditedBlob['path'] = 'story-image';
    this.uploader.addBlobs(imageEditedBlob);
   })
  }
  }

  async getBase64ImageFromUrl(imageUrl) {
    if(this.isBrowser){
    var res = await fetch(imageUrl);
    var blob = await res.blob();

    return new Promise((resolve, reject) => {
      var reader = new FileReader();
      reader.addEventListener("load", function () {
        resolve(reader.result);
      }, false);

      reader.onerror = () => {
        return reject(this);
      };
      reader.readAsDataURL(blob);
    })
  }
  }

  stopeffect(){
    if(this.isBrowser){
    this.blur = false;
    this.videoElement.nativeElement.srcObject = this.audioStream
    }
    // this.()
  }
  
  
  getConnectedDevices(type, callback,data?:any) {
    if(this.isBrowser){
    navigator.mediaDevices
        .getUserMedia({ audio: true,video:true })
        .then(()=>{
          navigator.mediaDevices.enumerateDevices()
          .then(devices => {
              const filtered = devices.filter(device => device.kind === type);
              callback(filtered);
          });
        })
      }
  }

  drawToCanvas() {
    if(this.isBrowser){
    const drawFrame = () => {
        this.canvasCtx.drawImage(this.videoElement.nativeElement, 0, 0, 640, 360);
        requestAnimationFrame(drawFrame);
      
    };
    drawFrame();
  }
  }

  CapturePhoto() {
    if(this.isBrowser){
      this.isRecording = false;
      this.stopRecordingVideo=true
      // Get the canvas element
      const canvas: HTMLCanvasElement = this.canvasCamera.nativeElement;
    
    
      // Draw the current frame from the video stream onto the canvas
      this.canvasCtx.drawImage(this.videoElement.nativeElement, 0, 0, 640, 360);
    
      // Convert the canvas content to an image data URL
      const imageData = canvas.toDataURL('image/png');
    
      // You can now use this imageData as the source for an <img> element, or save it as needed
      // For example, you can display it in an <img> element:
      // this.capturedPhoto = imageData;
    
      // Or you can save it using your uploader service
      this.savePhoto(imageData);
    }

  }
  savePhoto(imageData){
    this.getBase64ImageFromUrl(imageData).then((res: any) => {
      const imageEditedBlob = this.utility.File.b64ToBlob(res.replace(/^data:(image|binary)\/[^;]+;base64,/, ''), 'image/png');
      //this.previewMedia.fullsize = imageEditedB64;
      imageEditedBlob['path'] = 'story-image';
      this.isRecording = false;
      this.stopRecordingVideo=true
      if(this.stopRecordingVideo){
        if(this.initialState.showPreviousNextButton && !this.initialState.interViewStyle && this.campaignDetail){
          let obj ={
            blobcontent :imageEditedBlob,
            campaignDetail: this.campaignDetail
          }
          this.onClose.emit(obj)
        }
        else{
          let obj ={
            blobcontent :imageEditedBlob,
            campaignDetail:null
          }
          this.onClose.emit(obj)
        }
        
        }
       
        else{
          this.onClose.emit(false)
        }
     
     })
    }
}




